import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import type { LucideIcon } from 'lucide-react';
import { ChevronLeftIcon, XIcon } from 'lucide-react';
import React from 'react';
import { Heading } from './heading';

export interface HeaderProps extends React.PropsWithChildren {
    title?: React.ReactNode;
    subTitle?: string;
    actions?: React.ReactNode;
    onBack?: () => void;
    onClose?: () => void;
    icon?: LucideIcon;
    className?: string;
}

export const Header = ({
    className,
    title,
    actions,
    subTitle,
    onBack,
    onClose,
    icon: Icon,
    children,
}: HeaderProps) => {
    return (
        <div className={cn('flex flex-col gap-2', className)}>
            <div className="flex flex-row flex-wrap gap-3">
                <div className="flex gap-2 grow">
                    {onBack && <Button icon={ChevronLeftIcon} variant="icon" onClick={onBack} />}
                    <div className="flex grow flex-row items-center gap-2">
                        {Icon && <Icon className="h-4 w-4" />}
                        <Heading>{title}</Heading>
                        {children}
                    </div>
                </div>
                {(actions || onClose) && (
                    <div className="flex gap-3 flex-wrap">
                        {actions}
                        {onClose && <Button variant="icon" onClick={onClose} icon={XIcon} />}
                    </div>
                )}
            </div>
            {subTitle && (
                <div className="text-neutral-600">
                    <Heading variant="h3">{subTitle}</Heading>
                </div>
            )}
        </div>
    );
};
